<template>
  <div class="py-16 bg-gray-300">
    <div class="container">

      <div v-if="errors.cart_validation" class="flex bg-white rounded overflow-hidden mb-8">
        <div class="flex items-center px-2 bg-red-500 text-white">
          <Icon type="exclamation" size="10" />
        </div>
        <div class="px-6 py-5 text-gray-700 max-w-3xl">
          <ul class="space-y-3">
            <li v-for="(error, key) in errors.cart_validation" :key="key" class="leading-tight">
              {{ error }}
            </li>
          </ul>
        </div>
      </div>

      <div v-if="eventsCount" class="flex bg-white rounded overflow-hidden mb-8">
        <div class="flex items-center px-2 bg-yellow-500 text-white">
          <Icon type="exclamation" size="10" />
        </div>
        <div class="px-6 py-5 text-gray-700 max-w-3xl">
          <ul class="space-y-3">
            <li v-for="(count, event) in events" :key="event" class="leading-tight">
              Sie haben für <strong>{{ event }}</strong> Karten für <strong>{{ count }}</strong> unterschiedliche Termine im Warenkorb.
            </li>
          </ul>
        </div>
      </div>

      <template v-if="state.show && !state.expired">
        <div class="flex justify-between items-center mb-8">
          <div class="flex items-center">
            <div class="relative pt-2 pr-3">
              <Icon type="cart" size="8" />
              <div class="absolute flex bg-blue-500 text-white w-6 h-6 rounded-full top-0 right-0 leading-none">
                <span class="m-auto font-semibold text-sm">{{ count }}</span>
              </div>
            </div>
            <span class="font-semibold text-sm uppercase ml-2">Ihr Warenkorb</span>
          </div>
          <div v-if="state.expires_in" class="font-semibold text-sm uppercase">
            <span class="hidden sm:inline">Reservierungszeit:</span>
            {{ state.expires_in }}
            <span class="sm:hidden">Minuten</span>
          </div>
        </div>

        <CartWithButtons :cart="cart" />
      </template>

      <Empty v-else>
        <h1 class="text-2xl mb-2">Ihr Warenkorb ist leer</h1>
        <p class="text-lg text-gray-700">
          Zur Zeit befinden sich keine Artikel in Ihrem Warenkorb.<br>
          Zeit, ihn zu füllen!
        </p>
        <Link
          :href="route('home')"
          class="button w-64 py-3 mt-8"
          text="Zur Startseite"
        />
      </Empty>

    </div>
  </div>
</template>


<script>
import Layout from 'Web/Layouts/Default.vue';
import CartWithButtons from 'Web/Cart/CartWithButtons.vue';
import Empty from 'Web/Shared/Empty.vue';
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import { computed, onMounted, onUnmounted, reactive, watchEffect } from 'vue';
import dayjs from 'dayjs';
import useMeta from '@/compose/meta';
import rescue from '@/helpers/rescue';
import uniqBy from 'lodash/uniqBy';
import groupBy from 'lodash/groupBy';

export default {
  inheritAttrs: false,
  layout: Layout,
  components: {
    CartWithButtons,
    Empty,
    Icon,
    Link,
  },
  props: {
    cart: {
      type: Object,
      default: null,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { assign } = useMeta();

    assign({ title: 'DAS DA-Onlineshop - Warenkorb' });

    const state = reactive({
      expires_in: null,
      expired: null,
      show: null,
    });

    function product(line) {
      return line.type === 'product';
    }

    function amount(acc, line) {
      return acc + line.amount;
    }

    const count = computed(() => {
      if (!props.cart)
        return 0;

      return props.cart.lines
        .filter(product)
        .reduce(amount, 0);
    });

    const events = computed(() => {
      if (!props.cart)
        return {};

      const lines = props.cart.lines.filter(line =>
        line.linkable_type === 'ticket'
      );

      const events = groupBy(lines, 'name');
      const result = {};

      Object.keys(events).forEach(key => {
        const count = uniqBy(events[key], line =>
          rescue(() => JSON.parse(line.info).date)
        ).length;

        if (count > 1) result[key] = count;
      });

      return result;
    });

    const eventsCount = computed(() => Object.keys(events.value).length);

    function update() {
      if (!props.cart?.expired_at)
        return state.expired = false;

      if (dayjs(props.cart.expired_at).isBefore()) {
        state.expires_in = null;
        state.expired = true;
        return;
      }

      const date = new Date(null);
      const diff = dayjs(props.cart.expired_at).unix() - dayjs().unix();

      date.setSeconds(diff);

      state.expires_in = date.toISOString().substr(14, 5);
      state.expired = false;
    }

    let interval;

    onMounted(() => {
      interval = setInterval(update, 1000);
      update();
    });

    onUnmounted(() => {
      clearInterval(interval);
    });

    watchEffect(() => {
      state.show = props.cart && count.value;
    });

    // watch(() => count.value, () => {
    //   // Make it pop
    // });

    return {
      count,
      state,
      events,
      eventsCount,
    }
  }
}
</script>
